/**
 * @generated SignedSource<<15d0d5b9b0c1cea0f6e265e87aebd44b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgeRangeReportTable_site$data = {
  readonly reportAgeRange: any;
  readonly " $fragmentType": "AgeRangeReportTable_site";
};
export type AgeRangeReportTable_site = AgeRangeReportTable_site$data;
export type AgeRangeReportTable_site$key = {
  readonly " $data"?: AgeRangeReportTable_site$data;
  readonly " $fragmentSpreads": FragmentRefs<"AgeRangeReportTable_site">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgeRangeReportTable_site",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "kind": "ScalarField",
      "name": "reportAgeRange",
      "storageKey": null
    }
  ],
  "type": "Site",
  "abstractKey": null
};

(node as any).hash = "dd1888d308866109244512912a618476";

export default node;
